import { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { STORAGE_URL } from "../../../utils/constants";
import { Link } from "react-router-dom";
import './styles.css';

function BannerCarousel({ banners }) {
  const isRTL = document.documentElement.dir === 'rtl';

  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    direction: isRTL ? 'rtl' : 'ltr',
  });

  const [current, setCurrent] = useState(0);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setCurrent(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on('select', onSelect);

    // Auto-play
    if (banners.length < 2) return;
    const timer = setInterval(() => emblaApi.scrollNext(), 5000);
    return () => {
      clearInterval(timer);
      emblaApi.off('select', onSelect);
    };
  }, [emblaApi, onSelect, banners.length]);

  if (!banners.length) return null;

  return (
    <div className="banner-carousel">
      <div className="banner-viewport" ref={emblaRef}>
        <div className="banner-track">
          {banners.map((banner, i) => (
            <Link
              key={i}
              to={'/banner/' + banner.id}
              state={{ banner }}
              className="banner-slide"
            >
              <img src={STORAGE_URL + banner.image_url} alt={`banner-${i}`} />
            </Link>
          ))}
        </div>
      </div>

      {banners.length > 1 && (
        <>
          <div className="banner-dots">
            {banners.map((_, i) => (
              <span
                key={i}
                className={`banner-dot${i === current ? ' active' : ''}`}
                onClick={() => emblaApi?.scrollTo(i)}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default BannerCarousel;
